import IO from "./io";
import { ATGSagas } from "./ATG";
import { InvoiceSagas } from "./Invoice"
import { FileConverterSagas } from "./FileConverter";
import { DocumentsManagerHistorySagas } from "./DocumentsManagerHistory";
import { DocumentsManagerSagas } from "./DocumentsManager";

export default [
    ...IO,
    ...ATGSagas,
    ...InvoiceSagas,
    ...FileConverterSagas,
    ...DocumentsManagerHistorySagas,
    ...DocumentsManagerSagas
];
